import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="Brødkrumme" className="text-[13px] text-[#5C636B] mb-4 flex items-center flex-wrap gap-1.5 font-medium">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1.5">
            {idx > 0 && <span className="text-[#E4E1D8] select-none" aria-hidden="true">›</span>}
            {isLast ? (
              <span className="text-[#2E3A46] font-semibold" aria-current="page">
                {item.name}
              </span>
            ) : (
              <Link 
                to={item.path} 
                className="text-[#5C636B] hover:text-[#B58200] hover:underline underline-offset-2 transition-colors"
              >
                {item.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
